<template>
  <div>
  
  <!-- <HomeView v-if="location.indexOf('krhero') != -1"/> -->
  <!-- <maihaowangHome v-else-if="location.indexOf('hhzyou') != -1"/> -->




  <!-- <HomeView v-else-if="location.indexOf('shouyoubaoapp') != -1"/> -->

  <!-- <haomiaomiao v-else-if="location.indexOf('51haomiaomiao') != -1"/> -->


  <!-- <taohaobangHome v-else/> -->
  
 <!-- <taohaohaoMerchant /> -->
 <!-- <jiufangEsports />  -->

 <!-- <jiufangdianjing /> -->
 <yougou />

  <!-- <haomiaomiao /> -->

  <!-- <zijiecompany /> -->
  
  </div>
  
</template>

<script>
import { ref } from "vue";
import HomeView from "./HomeView.vue"
import thhHome from "./thhHome.vue"
import thwHome from "./thwHome.vue"
import mhbHome from "./mhbHome.vue"
import newThwHome from "./newThwHome.vue"
import taohaohao from "./taohaohao.vue"
import thbHome from "./thbHome.vue"
import taohaowangHome from "./taohaowangHome.vue"
import maihaowangHome from "./maihaowangHome.vue"
import iosMhb from "./iosMhb.vue"
import taohaobangHome from "./taohaobangHome.vue"
import company from './company.vue'
import taohaohaoMerchant from './merchant/taohaohaoMerchant.vue'
import haomiaomiao from "./haomiaomiao.vue";
import jiufangdianjing from "@/views/jiufangdianjing/company.vue";
import zijiecompany from "@/views/merchant/company.vue"
import jiufangEsports from "./jiufangdianjing/jiufangEsports.vue";
import yougou from "./jiufangdianjing/yougou.vue";


export default {
  name: "AboutView",
  components: {
    HomeView,
    thwHome,
    thhHome,
    mhbHome,
    newThwHome,
    taohaohao,
    thbHome,
    taohaowangHome,
    maihaowangHome,
    iosMhb,
    taohaobangHome,
    company,
    taohaohaoMerchant,
    haomiaomiao,
    jiufangdianjing,
    zijiecompany,
    jiufangEsports,
    yougou
    
  },
  setup() {

    const location = window.location.host //获取当前的域名
    console.log('22222')
    console.log(location)

    return {
      location
    };
  },
};


</script>

<style>

</style>

